import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { Home, History, LogOut, Shirt } from "lucide-react";
import { CloverLogo } from "../../components/CloverLogo";
import { usePortalAuth } from "../../context/PortalAuthContext";

export const PortalProtected = ({ children }) => {
  const { me } = usePortalAuth();
  if (me === null) return <div data-testid="portal-loading" className="flex min-h-screen items-center justify-center text-sm text-gray-500">Memuat…</div>;
  if (!me) return <Navigate to="/portal/login" replace />;
  return children;
};

const Tab = ({ to, icon: Icon, label, testid }) => (
  <NavLink to={to} end data-testid={testid}
    className={({ isActive }) => `flex flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-semibold active:scale-95 ${isActive ? "text-primary" : "text-gray-500"}`}>
    <Icon className="h-5 w-5" />{label}
  </NavLink>
);

export default function PortalLayout() {
  const { me, logout } = usePortalAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 border-b border-black/5 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex h-14 max-w-lg items-center justify-between px-4">
          <div className="flex items-center gap-2">
            <CloverLogo className="h-8 w-8" testid="portal-brand-logo" />
            <div className="leading-tight">
              <p className="font-heading text-xs font-semibold tracking-wide text-gray-900">CLOVER</p>
              <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500">Check-in Mandiri</p>
            </div>
          </div>
          <button data-testid="portal-logout-btn" onClick={() => { logout(); navigate("/portal/login"); }} className="flex h-10 items-center gap-1.5 rounded-full px-3 text-sm font-semibold text-gray-600 hover:bg-red-50 hover:text-red-700">
            <LogOut className="h-4 w-4" />Keluar
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-lg px-4 pb-28 pt-6">
        <p className="mb-1 text-sm text-gray-500">Halo,</p>
        <p data-testid="portal-nama" className="mb-6 font-heading text-2xl font-semibold text-gray-900">{me?.nama}</p>
        <Outlet />
      </main>
      {me?.face_registered && (
        <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-black/5 bg-white/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl">
          <div className="mx-auto flex h-16 max-w-lg">
            <Tab to="/portal" icon={Home} label="Beranda" testid="portal-tab-home" />
            <Tab to="/portal/peralatan" icon={Shirt} label="Peralatan" testid="portal-tab-peralatan" />
            <Tab to="/portal/riwayat" icon={History} label="Riwayat" testid="portal-tab-riwayat" />
          </div>
        </nav>
      )}
    </div>
  );
}
